<template>
  <div class="floor-search" :class="{gray}">
    <div class="container clearfix">
      <div class="logo-wrap">
        <router-link to="/">
          <img class="icon-logo" src="//s1.huishoubao.com/static/pc/1001/img/logo.png">
        </router-link>
      </div>
      <SearchForm></SearchForm>
    </div>
  </div>
</template>

<script>
import SearchForm from '../search-form';

export default {
  components: {
    SearchForm
  },
  computed: {
    gray () {
      return +new Date() < 1586016000000 && +new Date() > 1585929600000;
    }
  }
};
</script>

<style lang="postcss" scoped>
@import 'config.css';
.gray {
  -webkit-filter: grayscale(100%);
    filter: grayscale(100%);
}
.floor-search {
  padding: 10px 0;
  background-color: #fff;
}
.logo-wrap {
  float: left;
  .icon-logo {
    width: 225px;
  }
}
.product-search-wrap {
  float: right;
  width: 400px;
}
</style>



// WEBPACK FOOTER //
// src/projects/hsbpc/components/logo-search/index.vue